import {
  Autocomplete,
  Box,
  Fade,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Add, Delete } from "@mui/icons-material";

export const Disponibilidad = ({ horarios, setHorarios }) => {
  const [idNuevoHorario, setIdNuevoHorario] = useState(1);

  const diasSemana = [
    {
      id: "0",
      dia: "Domingo",
    },
    {
      id: "1",
      dia: "Lunes",
    },
    {
      id: "2",
      dia: "Martes",
    },
    {
      id: "3",
      dia: "Miércoles",
    },
    {
      id: "4",
      dia: "Jueves",
    },
    {
      id: "5",
      dia: "Viernes",
    },
    {
      id: "6",
      dia: "Sábado",
    },
  ];

  const horariosCeremonias = ["07:15", "08:00", "10:00", "18:30", "19:00"];

  const nuevoHorario = {
    id_oportunidad: idNuevoHorario,
    dia_semana: null,
    hora: "",
  };

  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "50%",
            margin: "auto",
          }}
        >
          <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
            Disponibilidad de horarios
          </Typography>
          <Typography variant="body" color="secondary.dark" fontSize={16}>
            Seleccione los días y horarios en los que el acólito está disponible
            para servir
          </Typography>
          <Box
            sx={
              (style.inputs,
              {
                display: "flex",
                flexDirection: "column",
                marginTop: 4,
              })
            }
          >
            {horarios.map((hora) => (
              <Box key={hora.id_oportunidad} sx={style.inputs}>
                <Tooltip title="Eliminar horario" placement="left">
                  <IconButton
                    onClick={() => {
                      setHorarios((h) => {
                        const horarios = h.filter(
                          (h) => h.id_oportunidad !== hora.id_oportunidad
                        );
                        return horarios;
                      });
                    }}
                  >
                    <Delete color={"primary"} />
                  </IconButton>
                </Tooltip>
                <Autocomplete
                  sx={{ width: 180, marginRight: 5 }}
                  options={diasSemana}
                  getOptionLabel={(option) => option.dia}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Día" />
                  )}
                  value={
                    diasSemana.find((d) => d.id === hora.dia_semana) || null
                  }
                  onChange={(event, value) => {
                    setHorarios((h) => {
                      const horarios = h.map((h) => {
                        if (h.id_oportunidad === hora.id_oportunidad) {
                          return {
                            ...h,
                            dia_semana: value ? value.id : null,
                          };
                        }
                        return h;
                      });
                      return horarios;
                    });
                  }}
                />
                <Autocomplete
                  sx={{
                    width: 120,
                  }}
                  freeSolo
                  options={horariosCeremonias}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Horario" />
                  )}
                  value={hora.hora.slice(0, 5) || null}
                  onInputChange={(event, value) => {
                    setHorarios((h) => {
                      const horarios = h.map((h) => {
                        if (h.id_oportunidad === hora.id_oportunidad) {
                          return {
                            ...h,
                            hora: value,
                          };
                        }
                        return h;
                      });
                      return horarios;
                    });
                  }}
                />
              </Box>
            ))}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 2,
                marginBottom: 2,
              }}
            >
              <Tooltip title="Agregar nuevo horario" placement="bottom">
                <IconButton
                  onClick={() => {
                    setIdNuevoHorario(idNuevoHorario + 1);
                    setHorarios([...horarios, { ...nuevoHorario }]);
                  }}
                  sx={{
                    backgroundColor: "secondary.light",
                  }}
                >
                  <Add
                    color={"primary"}
                    sx={{
                      fontSize: 30,
                    }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
    marginBottom: 5,
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    justifyContent: "space-around",
  },
};
